/**
 * @desc 导出物流箱单记录
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(tmsNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackWlxReport/${tmsNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
